import React, { createContext, useState, useContext } from 'react';

const TitleContext = createContext(undefined);

export const TitleProvider = ({ children }) => {
  const [currentPageName, setCurrentPageName] = useState('');

  const value = {
    currentPageName,
    setCurrentPageName,
  };

  return (
    <TitleContext.Provider value={value}>{children}</TitleContext.Provider>
  );
};

export const useTitle = () => {
  const context = useContext(TitleContext);
  if (context === undefined) {
    throw new Error('useTitle must be used within a TitleProvider');
  }
  return context;
};
